import { reactive } from "vue";

const previews = reactive(new Map());

export const previewsStore = previews;
